import * as React from 'react';
import Button from '@telia-front/button';
import Grid, { GridColumn } from '@telia-front/grid';
import Heading from '@telia-front/heading';
import Separator from '@telia-front/separator';
import Tag from '@telia-front/tag';
import Text from '@telia-front/text';
const TemplateTeliaWebNewsDetail = (props) => {
    return (React.createElement(Grid, null,
        React.createElement(GridColumn, { width: ['xs-12', 'md-8'] },
            React.createElement(Text, null,
                React.createElement(Heading, { className: "h2" }, props.title),
                React.createElement(Grid, { className: "text-small", gutter: "xsmall" },
                    React.createElement(GridColumn, { width: ['xs'] },
                        React.createElement("time", { dateTime: props.isoDate }, props.displayDate)),
                    props.tag && (React.createElement(GridColumn, { width: ['xs'] },
                        React.createElement(Tag, Object.assign({ size: "tiny" }, props.tag))))),
                React.createElement("p", { className: "h4" }, props.content),
                React.createElement("p", { className: "h6" }, props.content)),
            React.createElement(Separator, { spacing: "small", color: "invisible" }),
            React.createElement(Button, Object.assign({ variant: "secondary", iconLeft: "#arrow-left" }, props.button)))));
};
export default TemplateTeliaWebNewsDetail;
